<template>
    <div>
  
      <el-row style="margin-bottom:10px;">
        <el-col :span="18" class='flex'>
          <el-input v-model="getMicrolectureWareGroupList_data.ymwgName" placeholder="请输入名称" clearable size='small'
            style="max-width:200px;" />
          <el-button v-click.getMicrolectureWareGroupList type="primary" icon='el-icon-search' size='small'
            style='margin-left:10px;'>搜索
          </el-button>
        </el-col>
        <el-col :span="6">
          <el-button v-if="addMicrolectureWareGroup" @click=" $form('addMicrolectureWareGroup')" size='small' type="primary"
            style="float:right" icon='el-icon-circle-plus'>添加视频库分组
          </el-button>
        </el-col>
      </el-row>
  
      <mytable :tableColums='tableColums_getMicrolectureWareGroupList' api='getMicrolectureWareGroupList'
        xupdateapi='updateMicrolectureWareGroup' :height="H - 165">
      </mytable>
  
      <myform :viewobj='{
          addMicrolectureWareGroup: ["新增视频库分组", "el-icon-circle-plus"],
          updateMicrolectureWareGroup: ["修改视频库分组", "el-icon-edit-outline"],
          $succeed$: getMicrolectureWareGroupList
        }' @closed="$form('updateMicrolectureWareGroup', 'reset')">
        <template v-slot:mtmId="{ Myformdata }">
          <el-select v-model='Myformdata.mtmId' clearable>
            <el-option v-for="item in getMicrolectureTypeMainList_data || []" :key="item.mtmId" :label="item.mtmName"
              :value="item.mtmId"></el-option>
          </el-select>
        </template>
        <hide slot='mtId' />
        <hide slot='ymwgId' />
      </myform>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        mainType: [],
        mtId: null,
        theMtId: "",
        getMicrolectureTypeMainList_data: [],
        tableColums_getMicrolectureWareGroupList: {
          $selection: false,
  
          ymwgName: '分组名称',
          createtime: '创建时间',
  
          $operation: [
            '操作', 200,
            this.updateMicrolectureWareGroup && `@text: 编辑#warn
             @click: $form("updateMicrolectureWareGroup",$row)
            `,
            this.deleteMicrolectureWareGroup && `@text: 删除#danger
             @click: _confirm('确定要删除该微课吗?')
                     .trigger('deleteMicrolectureWareGroup',{ymwgId:$row.ymwgId})
                     .trigger('getMicrolectureWareGroupList')
            `,
          ],
  
        },
  
      };
    },
  
    watch: {
  
    },
  
    methods: {
    },
  
    async created() {
     
      this.getMicrolectureWareGroupList();
    }
  };
  </script>
  
  <style scoped></style>
  


// WEBPACK FOOTER //
// src/views/bussiness/videoBankGroup.vue